export class WatcherOptionEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public isManager!: boolean;
}
